import { isSlashPromptCommand, type PromptCommand } from './slash-command-constants';

const LEADING_PROMPT_COMMAND_PATTERN = /^\/([^\s]+)/;

export function hasValidPromptCommandBoundary(text: string, handle: string): boolean {
  const handleWithSlash = `/${handle}`;
  if (!text.startsWith(handleWithSlash)) return false;

  const afterHandle = text.slice(handleWithSlash.length);
  return afterHandle === '' || afterHandle.startsWith(' ');
}

export function findMatchingPromptCommand(text: string, commands: PromptCommand[]): PromptCommand | null {
  if (!text.startsWith('/')) return null;

  const match = text.match(LEADING_PROMPT_COMMAND_PATTERN);
  if (!match) return null;

  const typedHandle = match[1];
  const command = commands.find((item) => item.handle === typedHandle);

  if (command && hasValidPromptCommandBoundary(text, command.handle)) {
    return command;
  }

  return null;
}

export function renderPromptCommandContent(text: string, matchedCommand: PromptCommand | null): string {
  if (!matchedCommand || !text.startsWith(`/${matchedCommand.handle}`)) {
    return escapeText(text, true);
  }

  const handle = `/${matchedCommand.handle}`;
  const rest = text.slice(handle.length);
  const escapedRest = escapeText(rest, true);
  const escapedPlaceholder = isSlashPromptCommand(matchedCommand)
    ? escapeText(matchedCommand.instructionPlaceholder ?? '')
    : '';
  const hasExtraText = rest.trim().length > 0;
  const placeholderHtml =
    !hasExtraText && escapedPlaceholder
      ? `<span class="text-steel-300 pointer-events-none select-none" contenteditable="false" data-instruction-placeholder="true">${escapedPlaceholder}</span>`
      : '';

  return `<span class="text-fire-400">${handle}</span>${escapedRest}${placeholderHtml}`;
}

export function startsWithPromptCommand(text: string): boolean {
  return /^\/[\w-]+(?:\s|$)/.test(text);
}

function escapeText(text: string, preserveNewlines = false): string {
  const escapedText = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return preserveNewlines ? escapedText.replace(/\n/g, '<br>') : escapedText;
}
